import { validationError } from "../../globals";
import { z } from "zod";

export const ensurance = z.object({
  success: z.boolean().optional(),
  validationErrors: z.array(validationError).optional(),
});

export type Ensurance = z.infer<typeof ensurance>;
